import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'
import { getAllDocuments } from '@/services/documentPreview';

export interface Document {
    id: string;
    documentName: string;
    documentFile: string;
    documentType: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    updatedBy: string;
}

interface DocumentStore {
    documents: Document[];
    fetchDocuments: (params?: { [key: string]: string | number }) => Promise<void>;
}

export const useDocumentStore = create<DocumentStore>()(
    persist(
        (set) => ({
            documents: [],
            fetchDocuments: async (params: { [key: string]: string | number } = {}) => {
                const response = await getAllDocuments(params);
                // Handle both array and object with data property
                const data = Array.isArray(response) ? response : response?.data || [];
                set({ documents: data });
            }
        }),
        {
            name: 'document-storage',
            storage: createJSONStorage(() => localStorage),
        })
);

